import { createFileRoute } from '@tanstack/react-router';
import { AdminESignaturesPage } from '../../../components/portals/signing/AdminESignaturesPage';

export const Route = createFileRoute('/portal/managers/signing')({
  component: ManagersSigningContent,
});

function ManagersSigningContent() {
  return <AdminESignaturesPage />;
}
